import { Typography } from 'antd';
import { AppButton } from 'shared/UI/UIKit/Button';
import { AppFlex } from 'shared/UI/UIKit/Flex';
import { AppInputNumber } from 'shared/UI/UIKit/InputNumber';
import { AppModal, AppModalFooter } from 'shared/UI/UIKit/Modal';
import type { ScheduleConstraintCategory } from 'services/api/schedule-configuration';
import { scheduleConstraintLabels } from '../../../../model';
import { useConstraintWeightsModal, type ConstraintWeightsModalProps } from '../model';
import styles from './styles.module.scss';

const categoryLabels: Record<ScheduleConstraintCategory, string> = {
  LOGICAL: 'Логические ограничения',
  SANPIN: 'Ограничения СанПиН',
};

export const ConstraintWeightsModal = ({
  open,
  onClose,
  onSave,
  logicalConstraints,
  sanpinConstraints,
  weights,
  readOnly,
}: ConstraintWeightsModalProps) => {
  const {
    state: { constraintGroups },
    methods: { getScore, isInputDisabled, handleScoreChange, handleSave, handleClose },
  } = useConstraintWeightsModal({
    open,
    onClose,
    onSave,
    weights,
    readOnly,
    logicalConstraints,
    sanpinConstraints,
  });

  return (
    <AppModal
      visible={open}
      onCancel={handleClose}
      title="Вес ограничений"
      size="large"
      content={
        <div>
          <div className={styles.tableHeader}>
            <Typography.Text strong>Ограничение</Typography.Text>
            <Typography.Text strong>Жёсткий вес</Typography.Text>
            <Typography.Text strong>Мягкий вес</Typography.Text>
          </div>
          {constraintGroups.map(({ category, constraints }) => (
            <section key={category} className={styles.section}>
              <Typography.Title level={5} className={styles.sectionTitle}>
                {categoryLabels[category]}
              </Typography.Title>
              {constraints.map((constraint) => {
                const disabled = isInputDisabled(constraint, category);

                return (
                  <div key={constraint.code} className={styles.row}>
                    <Typography.Text disabled={disabled}>
                      {scheduleConstraintLabels[constraint.code] ?? constraint.code}
                    </Typography.Text>
                    <AppInputNumber
                      min={0}
                      precision={0}
                      value={getScore(constraint.code, 'hardScore')}
                      onChange={(value) =>
                        handleScoreChange(constraint, category, 'hardScore', value)
                      }
                      disabled={disabled}
                    />
                    <AppInputNumber
                      min={0}
                      precision={0}
                      value={getScore(constraint.code, 'softScore')}
                      onChange={(value) =>
                        handleScoreChange(constraint, category, 'softScore', value)
                      }
                      disabled={disabled}
                    />
                  </div>
                );
              })}
            </section>
          ))}
        </div>
      }
      customFooter={
        <AppModalFooter direction="row" unit="8" justifyContent="flex-end">
          <AppFlex direction="row" unit="8" justifyContent="flex-end">
            <AppButton type="outline" onClick={handleClose}>
              {readOnly ? 'Закрыть' : 'Отмена'}
            </AppButton>
            {!readOnly && (
              <AppButton type="primary" onClick={handleSave}>
                Сохранить
              </AppButton>
            )}
          </AppFlex>
        </AppModalFooter>
      }
      destroyOnClose
      maskClosable={false}
    />
  );
};
